/* eslint-disable @atlaskit/platform/no-inline-images -- baseline: pre-existing inline image, do not add new ones */
import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { fg } from '@confluence/feature-gating';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const wrapperStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget': {
		// By default, hide the widget
		display: 'none',
		position: 'relative',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-left': {
		left: '16px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-right': {
		left: '-16px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-small.link-widget-right': {
		left: '-10px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.heading-link-copy-button': {
		position: 'absolute',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		height: '24px',
		left: '-12px',
		top: '50%',
		transform: 'translateY(-50%)',
		paddingTop: 0,
		paddingRight: 0,
		paddingBottom: 0,
		paddingLeft: 0,
		border: 0,
		backgroundColor: 'transparent',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.heading-link-copy-button-icon': {
		position: 'relative',
		display: 'inline-flex',
		width: '24px',
		height: '24px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.heading-link-copy-button-icon::after': {
		display: 'block',
	},
	// Override the legacy medium/small icon dimensions for experiment-only copy buttons.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.heading-link-copy-button-icon.link-widget-medium::after, .heading-link-copy-button-icon.link-widget-small::after':
		{
			position: 'absolute',
			left: 0,
			top: 0,
			marginLeft: 0,
			width: '24px',
			height: '24px',
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'h1:hover .link-widget, h2:hover .link-widget, h3:hover .link-widget, h4:hover .link-widget, h5:hover .link-widget, h6:hover .link-widget':
		{
			// On hover, show the widget
			display: 'inline',
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget::after': {
		// This value is chosen intentionally and relative to the `left`
		// property above to force centering with the tooltip.
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		marginLeft: '-10px',
		position: 'absolute',
		cursor: 'pointer',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-hovered-light::after': {
		// This is the Base64 encoding of the link-light.svg found in this package. The imported
		// SVG could not be used due to an issue with webpack in the build. The file should
		// remain in place for reference, even though it's not actively used.
		content:
			'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjQgNCAxNiAxNiIgcm9sZT0icHJlc2VudGF0aW9uIj48cGF0aCBkPSJNMTIuNjU0IDguNzY0YS44NTguODU4IDAgMDEtMS4yMTMtMS4yMTNsMS4yMTQtMS4yMTRhMy43MTcgMy43MTcgMCAwMTUuMjU3IDAgMy43MTQgMy43MTQgMCAwMS4wMDEgNS4yNThsLTEuMjE0IDEuMjE0LS44MDQuODA0YTMuNzIgMy43MiAwIDAxLTUuMjYzLjAwNS44NTguODU4IDAgMDExLjIxNC0xLjIxNGMuNzgxLjc4MiAyLjA1Ljc4IDIuODM2LS4wMDVsLjgwNC0uODAzIDEuMjE0LTEuMjE0YTEuOTk4IDEuOTk4IDAgMDAtLjAwMS0yLjgzMSAyIDIgMCAwMC0yLjgzIDBsLTEuMjE1IDEuMjEzem0tLjgwOCA2LjQ3MmEuODU4Ljg1OCAwIDAxMS4yMTMgMS4yMTNsLTEuMjE0IDEuMjE0YTMuNzE3IDMuNzE3IDAgMDEtNS4yNTcgMCAzLjcxNCAzLjcxNCAwIDAxLS4wMDEtNS4yNThsMS4yMTQtMS4yMTQuODA0LS44MDRhMy43MiAzLjcyIDAgMDE1LjI2My0uMDA1Ljg1OC44NTggMCAwMS0xLjIxNCAxLjIxNCAyLjAwNSAyLjAwNSAwIDAwLTIuODM2LjAwNWwtLjgwNC44MDNMNy44IDEzLjYxOGExLjk5OCAxLjk5OCAwIDAwLjAwMSAyLjgzMSAyIDIgMCAwMDIuODMgMGwxLjIxNS0xLjIxM3oiIGZpbGw9IiM2MjZGODYiLz48L3N2Zz4=)',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-hovered-dark::after': {
		// link-dark.svg
		content:
			'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjQgNCAxNiAxNiIgcm9sZT0icHJlc2VudGF0aW9uIj48cGF0aCBkPSJNMTIuNjU0IDguNzY0YS44NTguODU4IDAgMDEtMS4yMTMtMS4yMTNsMS4yMTQtMS4yMTRhMy43MTcgMy43MTcgMCAwMTUuMjU3IDAgMy43MTQgMy43MTQgMCAwMS4wMDEgNS4yNThsLTEuMjE0IDEuMjE0LS44MDQuODA0YTMuNzIgMy43MiAwIDAxLTUuMjYzLjAwNS44NTguODU4IDAgMDExLjIxNC0xLjIxNGMuNzgxLjc4MiAyLjA1Ljc4IDIuODM2LS4wMDVsLjgwNC0uODAzIDEuMjE0LTEuMjE0YTEuOTk4IDEuOTk4IDAgMDAtLjAwMS0yLjgzMSAyIDIgMCAwMC0yLjgzIDBsLTEuMjE1IDEuMjEzem0tLjgwOCA2LjQ3MmEuODU4Ljg1OCAwIDAxMS4yMTMgMS4yMTNsLTEuMjE0IDEuMjE0YTMuNzE3IDMuNzE3IDAgMDEtNS4yNTcgMCAzLjcxNCAzLjcxNCAwIDAxLS4wMDEtNS4yNThsMS4yMTQtMS4yMTQuODA0LS44MDRhMy43MiAzLjcyIDAgMDE1LjI2My0uMDA1Ljg1OC44NTggMCAwMS0xLjIxNCAxLjIxNCAyLjAwNSAyLjAwNSAwIDAwLTIuODM2LjAwNWwtLjgwNC44MDNMNy44IDEzLjYxOGExLjk5OCAxLjk5OCAwIDAwLjAwMSAyLjgzMSAyIDIgMCAwMDIuODMgMGwxLjIxNS0xLjIxM3oiIGZpbGw9IiM4QzlCQUIiLz48L3N2Zz4=)',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-clicked-light::after': {
		// link-clicked-light.svg
		content:
			'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjQgNCAxNiAxNiIgcm9sZT0icHJlc2VudGF0aW9uIj48cGF0aCBkPSJNMTIuNjU0IDguNzY0YS44NTguODU4IDAgMDEtMS4yMTMtMS4yMTNsMS4yMTQtMS4yMTRhMy43MTcgMy43MTcgMCAwMTUuMjU3IDAgMy43MTQgMy43MTQgMCAwMS4wMDEgNS4yNThsLTEuMjE0IDEuMjE0LS44MDQuODA0YTMuNzIgMy43MiAwIDAxLTUuMjYzLjAwNS44NTguODU4IDAgMDExLjIxNC0xLjIxNGMuNzgxLjc4MiAyLjA1Ljc4IDIuODM2LS4wMDVsLjgwNC0uODAzIDEuMjE0LTEuMjE0YTEuOTk4IDEuOTk4IDAgMDAtLjAwMS0yLjgzMSAyIDIgMCAwMC0yLjgzIDBsLTEuMjE1IDEuMjEzem0tLjgwOCA2LjQ3MmEuODU4Ljg1OCAwIDAxMS4yMTMgMS4yMTNsLTEuMjE0IDEuMjE0YTMuNzE3IDMuNzE3IDAgMDEtNS4yNTcgMCAzLjcxNCAzLjcxNCAwIDAxLS4wMDEtNS4yNThsMS4yMTQtMS4yMTQuODA0LS44MDRhMy43MiAzLjcyIDAgMDE1LjI2My0uMDA1Ljg1OC44NTggMCAwMS0xLjIxNCAxLjIxNCAyLjAwNSAyLjAwNSAwIDAwLTIuODM2LjAwNWwtLjgwNC44MDNMNy44IDEzLjYxOGExLjk5OCAxLjk5OCAwIDAwLjAwMSAyLjgzMSAyIDIgMCAwMDIuODMgMGwxLjIxNS0xLjIxM3oiIGZpbGw9IiMwQzY2RTQiLz48L3N2Zz4=)',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-clicked-dark::after': {
		// link-clicked-dark.svg
		content:
			'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjQgNCAxNiAxNiIgcm9sZT0icHJlc2VudGF0aW9uIj48cGF0aCBkPSJNMTIuNjU0IDguNzY0YS44NTguODU4IDAgMDEtMS4yMTMtMS4yMTNsMS4yMTQtMS4yMTRhMy43MTcgMy43MTcgMCAwMTUuMjU3IDAgMy43MTQgMy43MTQgMCAwMS4wMDEgNS4yNThsLTEuMjE0IDEuMjE0LS44MDQuODA0YTMuNzIgMy43MiAwIDAxLTUuMjYzLjAwNS44NTguODU4IDAgMDExLjIxNC0xLjIxNGMuNzgxLjc4MiAyLjA1Ljc4IDIuODM2LS4wMDVsLjgwNC0uODAzIDEuMjE0LTEuMjE0YTEuOTk4IDEuOTk4IDAgMDAtLjAwMS0yLjgzMSAyIDIgMCAwMC0yLjgzIDBsLTEuMjE1IDEuMjEzem0tLjgwOCA2LjQ3MmEuODU4Ljg1OCAwIDAxMS4yMTMgMS4yMTNsLTEuMjE0IDEuMjE0YTMuNzE3IDMuNzE3IDAgMDEtNS4yNTcgMCAzLjcxNCAzLjcxNCAwIDAxLS4wMDEtNS4yNThsMS4yMTQtMS4yMTQuODA0LS44MDRhMy43MiAzLjcyIDAgMDE1LjI2My0uMDA1Ljg1OC44NTggMCAwMS0xLjIxNCAxLjIxNCAyLjAwNSAyLjAwNSAwIDAwLTIuODM2LjAwNWwtLjgwNC44MDNMNy44IDEzLjYxOGExLjk5OCAxLjk5OCAwIDAwLjAwMSAyLjgzMSAyIDIgMCAwMDIuODMgMGwxLjIxNS0xLjIxM3oiIGZpbGw9IiM1NzlERkYiLz48L3N2Zz4=)',
	},
	// H1 - H3
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-medium::after': {
		width: '20px',
		height: '20px',
	},
	// H4 - H6
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-small::after': {
		width: '14px',
		height: '14px',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const blockControlHeadingLinkFixStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-left': {
		// Reserve enough inline space for the copy-link control so the heading wraps before the
		// control reaches the editor gutter.
		left: 'auto',
		paddingRight: token('space.400'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-right, .link-widget-small.link-widget-right': {
		// Right-aligned headings render the decoration before the heading text.
		left: 'auto',
		paddingLeft: token('space.400'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.heading-link-copy-button': {
		left: token('space.050'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Heading decorations are rendered into a separate ProseMirror widget tree.
	'.link-widget-right .heading-link-copy-button': {
		left: 'auto',
		right: token('space.050'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget::after': {
		marginLeft: 0,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-left::after': {
		left: token('space.075'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'.link-widget-right::after': {
		right: token('space.075'),
	},
});

type HeadingLinksStyleWrapperProps = {
	children: React.ReactNode;
};
export const HeadingLinksStyleWrapper = ({
	children,
}: HeadingLinksStyleWrapperProps): React.JSX.Element => {
	return (
		<div
			css={[
				wrapperStyles,
				fg('platform_editor_block_control_heading_link_fix') && blockControlHeadingLinkFixStyles,
			]}
		>
			{children}
		</div>
	);
};
